import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getMessaging, getToken } from "@firebase/messaging";
import { getAuth } from "firebase/auth";

let firebaseConfig = {
  apiKey: process.env.REACT_APP_apiKey,
  authDomain: process.env.REACT_APP_authDomain,
  projectId: process.env.REACT_APP_projectId,
  storageBucket: process.env.REACT_APP_storageBucket,
  messagingSenderId: process.env.REACT_APP_messagingSenderId,
  appId: process.env.REACT_APP_appId,
  measurementId: process.env.REACT_APP_measurementId,
};
const app = initializeApp(firebaseConfig);
export const auth = getAuth();
export const db = getFirestore(app);
const messaging = getMessaging(app);
export const fetchToken = () => {
  return getToken(messaging, {
    vapidKey: process.env.REACT_APP_vapidKey,
  })
    .then((currentToken) => {
      if (currentToken) {
      } else {
        console.log("No Token Found!!");
      }
    })
    .catch((error) => {
      console.log("Error Occured: ", error);
    });
};
